import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark-900 border-t border-dark-600/50 mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-accent-purple to-accent-pink rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">💬</span>
              </div>
              <h3 className="text-2xl font-display font-bold text-white">
                LoveChat<span className="text-accent-pink">.ai</span>
              </h3>
            </div>
            <p className="text-dark-300 text-sm leading-relaxed mb-6 max-w-md">
              Connect with AI companions that understand you. Experience meaningful conversations, 
              build relationships, and discover new connections in a safe, welcoming environment.
            </p>
            <div className="flex items-center gap-4">
              <button
                className="w-10 h-10 bg-dark-800 hover:bg-dark-700 rounded-lg flex items-center justify-center text-dark-400 hover:text-white transition-all duration-200"
                aria-label="Twitter"
                onClick={() => window.open('https://twitter.com', '_blank')}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.0956Z" />
                </svg>
              </button>
              <button
                className="w-10 h-10 bg-dark-800 hover:bg-dark-700 rounded-lg flex items-center justify-center text-dark-400 hover:text-white transition-all duration-200"
                aria-label="Discord"
                onClick={() => window.open('https://discord.gg', '_blank')}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0002 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9554 2.4189-2.1568 2.4189Z"/>
                </svg>
              </button>
              <button
                className="w-10 h-10 bg-dark-800 hover:bg-dark-700 rounded-lg flex items-center justify-center text-dark-400 hover:text-white transition-all duration-200"
                aria-label="GitHub"
                onClick={() => window.open('https://github.com', '_blank')}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-dark-300 hover:text-white text-sm transition-colors duration-200">
                  Home
                </a>
              </li>
              <li>
                <a href="/girls" className="text-dark-300 hover:text-white text-sm transition-colors duration-200">
                  Girls
                </a>
              </li>
              <li>
                <a href="/anime" className="text-dark-300 hover:text-white text-sm transition-colors duration-200">
                  Anime
                </a>
              </li>
              <li>
                <a href="/guys" className="text-dark-300 hover:text-white text-sm transition-colors duration-200">
                  Guys
                </a>
              </li>
              <li>
                <a href="/create" className="text-dark-300 hover:text-white text-sm transition-colors duration-200">
                  Create Companion
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  className="text-dark-300 hover:text-white text-sm transition-colors duration-200 text-left"
                  onClick={() => window.open('/help', '_blank')}
                >
                  Help Center
                </button>
              </li>
              <li>
                <button 
                  className="text-dark-300 hover:text-white text-sm transition-colors duration-200 text-left"
                  onClick={() => window.open('/privacy', '_blank')}
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button 
                  className="text-dark-300 hover:text-white text-sm transition-colors duration-200 text-left"
                  onClick={() => window.open('/terms', '_blank')}
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button 
                  className="text-dark-300 hover:text-white text-sm transition-colors duration-200 text-left"
                  onClick={() => window.open('/guidelines', '_blank')}
                >
                  Community Guidelines
                </button>
              </li>
              <li>
                <button 
                  className="text-dark-300 hover:text-white text-sm transition-colors duration-200 text-left"
                  onClick={() => window.open('/contact', '_blank')}
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-dark-600/50 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-dark-400 text-sm">
            © 2024 LoveChat.ai. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-sm">
            <span className="text-dark-400">Made with</span>
            <span className="text-red-400">❤️</span>
            <span className="text-dark-400">for meaningful connections</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;